import React from "react";
import Header from "../component/Header";
import Footer from "../component/footer";

const Checkout = () => {
  return (
    <div>
      <Header />

      <section className="main">
        <div className="container checkout-page-wrap">
          <div className="checkout-panel-card">
            <div className="details-card">
              <h2 className="font-bold checkout-title">
                Complete Payment for Standard
              </h2>
              <p className="checkout-note">
                Server-to-server checkout: validate your IBAN and payment will
                be submitted automatically.
              </p>
              <h2 className="font-bold checkout-title">Your Information</h2>
              <div className="billing-details-fields">
                <div className="form-row">
                  <div className="form-group full">
                    <label>
                      Email <span>*</span>
                    </label>
                    <input type="email" placeholder="john.doe@example.com " />
                  </div>
                  <div className="form-group full">
                    <label>
                      Password <span>*</span>
                    </label>
                    <span className="password-input">
                      <input
                        type="password"
                        placeholder="Password"
                        name="account_password"
                        id="account_password"
                      />
                      <button
                        type="button"
                        className="show-password-input"
                        aria-label="Show password"
                        aria-describedby="account_password"
                      />
                    </span>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group full">
                    <label>
                      First name <span>*</span>
                    </label>
                    <input type="text" placeholder="John" />
                  </div>
                  <div className="form-group full">
                    <label>
                      Last name <span>*</span>
                    </label>
                    <input type="text" placeholder="Doe" />
                  </div>
                </div>
                <div className="form-group full">
                  <label>
                    Phone <span>*</span>
                  </label>
                  <input type="tel" placeholder="+46 70 123 45 67" />
                </div>
              </div>
              <h2 className="font-bold checkout-title">Your Billing Details</h2>
              <div className="billing-details-fields">
                <div className="form-row">
                  <div className="form-group full">
                    <label>
                      Street address <span>*</span>
                    </label>
                    <input type="text" />
                  </div>
                  <div className="form-group full">
                    <label>
                      Town / City <span>*</span>
                    </label>
                    <input type="text" />
                  </div>
                </div>
                <div className="form-row bottom-row">
                  <div className="form-group postcode">
                    <label>
                      Postcode / ZIP <span>*</span>
                    </label>
                    <input type="text" />
                  </div>
                  <div className="form-group country">
                    <label>
                      Country <span>*</span>
                    </label>
                    <div className="select-wrap">
                      <select className="custom-select h-[46px]">
                        <option>Sweden</option>
                        <option>India</option>
                        <option>USA</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h2 className="font-bold checkout-title">
                SEPA Direct Debit Information
              </h2>
              <div className="payment-box">
                <label className="payment-header">
                  <input type="radio" name="payment" id="sepaRadio" checked />
                  <div className="custom-radio" />
                  <span className="payment-title">SEPA Direct Debit</span>
                  <img src=".\sepa.svg" alt="SEPA" />
                </label>
                <div className="payment-content">
                  <p className="checkout-note">
                    Mandate Information.
                    <br /> By providing your IBAN and confirming this payment,
                    you are authorizing us to send instructions to your bank to
                    debit your account and your bank to debit your account in
                    accordance with those instructions. You are entitled to a
                    refund from your bank under the terms and conditions of your
                    agreement with your bank. A refund must be claimed within 8
                    weeks starting from the date on which your account was
                    debited.
                  </p>
                  <div className="checkout-fields">
                    <label>
                      IBAN <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="IBAN (e.g. DE89370400440532013000)"
                      autoComplete="off"
                      className="checkout-input"
                      defaultValue=""
                    />
                  </div>
                  <h2 className="font-bold checkout-title">
                    Payment Information
                  </h2>
                  <p className="mb-0 checkout-note">
                    All transactions are secure and encrypted. Credit card
                    information is never stored on our servers.
                  </p>
                </div>
              </div>
              <p className="mt-3 text-[#4b5563] text-center">
                Your personal data will be used to process your order, support
                your experience throughout this website, and for other purposes
                described in our privacy policy .
              </p>
              <div className="place-btn-wrapper">
                <button
                  type="submit"
                  className="font-semibold place-order bg-[#4ce470] text-[#113a28] px-8 py-4 rounded-[999px] font-bold text-sm hover:bg-[#3bc45d] transition-colors shadow-lg shadow-gray-300"
                  name="place_order"
                  id="place_order"
                  value="Complete Your Order Now"
                  data-value="Complete Your Order Now"
                >
                  Complete Your Order Now
                </button>
              </div>
              <div className="sepa-icon">
                <img
                  src=".\SEPA Logo PNG Vector (SVG) Free Download.jpg"
                  alt="SEPA"
                />
              </div>
              <div className="checkout-features">
                <div className="feature-item">
                  <div className="feature-title">
                    <img src=".\time.svg" />
                  </div>
                  <div className="feature-text text-[#4b5563]">
                    <strong>Cancel Anytime</strong>
                    Cancel anytime, see T&amp;Cs for more info
                  </div>
                </div>
                <div className="feature-item">
                  <div className="feature-title">
                    <img src=".\lock.svg" />
                  </div>
                  <div className="feature-text text-[#4b5563]">
                    <strong>Secure Processing</strong>
                    Encrypted, secure order processing
                  </div>
                </div>
              </div>
              <p className="text-center checkout-note">
                We use GoCardless to process your Direct Debit payments. More
                information on how GoCardless processes your personal data and
                your data protection rights, including your right to object, is
                available at{" "}
                <a href="#" target="_blank" rel="noopener noreferrer">
                  gocardless.com/legal/privacy/
                </a>
              </p>
              <div className="guarantee-box">
                <div className="logo-wrap">
                  <img src=".\direct debit.png" alt="Direct Debit Logo" />
                </div>
                <div className="guarantee-title">Direct Debit Guarantee</div>
              </div>
            </div>
            <div className="subscription-card">
              <h2>Subscription Information</h2>
              <div className="subscription-item">
                <div className="product-image">
                  <img src=".\zr-1.svg" alt="product" />
                </div>
                <div className="product-info">
                  <div className="top-row">
                    <h3>Monthly Unlimited Subscription -</h3>
                    <span className="price">€59.98</span>
                  </div>
                  <p>Rebills every month, with a 3-day free trial</p>
                  <div className="font-light billing-info text-[#4ce470] text-[14px]">
                    <span>Next Billing:</span>
                    <span>2026-06-11</span>
                  </div>
                </div>
              </div>

              <div className="divider" />
              <div className="summary-row">
                <span>Subtotal</span>
                <span>€59.98</span>
              </div>
              <div className="divider" />
              <div className="total-row">
                <span>Total</span>
                <span>€59.98</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Checkout;
